import type { MapProgressData } from '../MapProgress';
import type { SaveProvider } from './SaveProvider';

// Последний fallback — если ни Telegram, ни localStorage недоступны (приватный режим
// без поддержки в.т.ч). Прогресс живёт только в этой инстанции, между сессиями теряется.
export class InMemorySaveProvider implements SaveProvider {
  readonly name = 'inMemory';
  private data: MapProgressData | null = null;

  async save(data: MapProgressData): Promise<void> {
    this.data = data;
  }

  async load(): Promise<MapProgressData | null> {
    return this.data;
  }

  async clear(): Promise<void> {
    this.data = null;
  }
}
